import PropTypes from 'prop-types';
import React from 'react';
import { FontIcon } from 'react-toolbox';
import Card from 'components/Card';
import EmployableEventList from './employableEventList';
import S from './employableHistoryCard.scss';
import contentAreaStyles from 'styles/contentArea';

class EmployableHistoryCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.collapsed,
      icon: props.collapsed ? 'down' : 'up',
      clientHeight: 0,
    };
  }

  // On the first render, the component has no reference to the contentWrapper
  // and its height. We need to trigger another render if the component is
  // initially expanded so that it displays properly.
  componentDidMount = () => (this.contentWrapper !== null ?
    this.setState({ clientHeight: this.contentWrapper.clientHeight }) : null);

  componentDidUpdate = prevProps => (prevProps.collapsed !== this.props.collapsed ?
    this.setState({ collapsed: this.props.collapsed }) : null);

  handleClick = () => this.setState({
    collapsed: !this.state.collapsed,
    icon: this.state.collapsed ? 'up' : 'down',
  });

  render = () => {
    const { collapsed, clientHeight } = this.state;
    const { events, name, employableType } = this.props;
    const icon = `arrow_drop_${this.state.icon}`;
    const iconStyle = S.employableHistoryCard__collapseToggle;
    const heightStyle = {};
    if (collapsed) heightStyle.maxHeight = 0;
    else { heightStyle.maxHeight = (clientHeight || 0) + 500; }
    return (
      <Card className={`${S.employableHistoryCard__container} ${contentAreaStyles.contentArea}`}>
        <section className={S.employableHistoryCard}>
          <div className={S.employableHistoryCard__title}>
            <span>{name}</span>
            <FontIcon value={icon} onClick={this.handleClick} className={iconStyle} />
          </div>
          <div className={S.employableHistoryCard__content} style={heightStyle}>
            <div ref={(wrapper) => { this.contentWrapper = wrapper; }}>
              <EmployableEventList events={events} employableType={employableType} />
            </div>
          </div>
        </section>
      </Card>
    );
  }
}

EmployableHistoryCard.propTypes = {
  name: PropTypes.string,
  collapsed: PropTypes.bool,
  events: PropTypes.arrayOf(PropTypes.object),
  employableType: PropTypes.string,
};

export default EmployableHistoryCard;



// WEBPACK FOOTER //
// ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/index.jsx